import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { SnackbarProvider } from 'notistack';

import store from '@app/store';

import dayjs, { locale } from '@app/utils/Dayjs';

import App from '@app/App';

import '@app/index.css';
import theme from '@app/theme';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={locale}
            dateLibInstance={dayjs.utc}
          >
            <SnackbarProvider>
              <Router basename={process.env.REACT_APP_PUBLIC_URL}>
                <App />
              </Router>
            </SnackbarProvider>
          </LocalizationProvider>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
